import { useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { clientsApi } from '@/lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { Save } from 'lucide-react'

export function RagEditor({ client }: { client: any }) {
  const [markdown, setMarkdown] = useState(client.ragMarkdown || '')
  const queryClient = useQueryClient()

  const { mutate: saveRag, isPending } = useMutation({
    mutationFn: () => clientsApi.updateRAG(client.id, markdown),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['client', client.id] })
      toast.success('RAG 知识库已更新')
    },
    onError: (error: any) => {
      toast.error(error.error || '更新失败')
    }
  })

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>RAG 知识库 (Markdown)</CardTitle>
        <Button onClick={() => saveRag()} disabled={isPending}>
          <Save className="mr-2 h-4 w-4" /> {isPending ? '保存中...' : '保存修改'}
        </Button>
      </CardHeader>
      <CardContent>
        <Textarea
          value={markdown}
          onChange={(e) => setMarkdown(e.target.value)}
          placeholder="在此输入客户特定的翻译规范、风格指南或背景知识..."
          className="min-h-[500px] font-mono"
        />
      </CardContent>
    </Card>
  )
}
